import React from "react";
import {
  ContentSafetySettings,
  initialModerationSettings,
  ModerationFlag,
} from "../../components/adminDashboard/ContentSafety";

type EmailsState = {
  sexual: string;
  hate: string;
  harassment: string;
  selfHarm: string;
  violence: string;
  withdrawal: string;
  ada: string;
};

type Props = {
  contentSafety: {
    sexual: boolean;
    hate: boolean;
    harassment: boolean;
    selfHarm: boolean;
    violence: boolean;
    withdrawal: boolean;
    ada: boolean;
  };
  setContentSafety: React.Dispatch<
    React.SetStateAction<{
      sexual: boolean;
      hate: boolean;
      harassment: boolean;
      selfHarm: boolean;
      violence: boolean;
      withdrawal: boolean;
      ada: boolean;
    }>
  >;
  emailsState: EmailsState;
  setEmailsState: React.Dispatch<React.SetStateAction<EmailsState>>;
};

function AdminContentSafetySettingsContainer({ contentSafety, setContentSafety, emailsState, setEmailsState }: Props) {
  const moderationFlags: ModerationFlag[] = initialModerationSettings.map((flag) => ({
    ...flag,
    enabled: contentSafety[flag.id as keyof typeof contentSafety] ?? false,
    emails: emailsState[flag.id as keyof EmailsState] ?? "",
  }));

  return (
    <ContentSafetySettings
      moderationSettings={moderationFlags}
      onSettingsChange={(newFlags) => {
        const mapped = {
          sexual: newFlags.find((f) => f.id === "sexual")?.enabled ?? false,
          hate: newFlags.find((f) => f.id === "hate")?.enabled ?? false,
          harassment: newFlags.find((f) => f.id === "harassment")?.enabled ?? false,
          selfHarm: newFlags.find((f) => f.id === "selfHarm")?.enabled ?? false,
          violence: newFlags.find((f) => f.id === "violence")?.enabled ?? false,
          withdrawal: newFlags.find((f) => f.id === "withdrawal")?.enabled ?? false,
          ada: newFlags.find((f) => f.id === "ada")?.enabled ?? false,
        };
        setContentSafety(mapped);

        const newEmails: EmailsState = {
          sexual: newFlags.find((f) => f.id === "sexual")?.emails ?? "",
          hate: newFlags.find((f) => f.id === "hate")?.emails ?? "",
          harassment: newFlags.find((f) => f.id === "harassment")?.emails ?? "",
          selfHarm: newFlags.find((f) => f.id === "selfHarm")?.emails ?? "",
          violence: newFlags.find((f) => f.id === "violence")?.emails ?? "",
          withdrawal: newFlags.find((f) => f.id === "withdrawal")?.emails ?? "",
          ada: newFlags.find((f) => f.id === "ada")?.emails ?? "",
        };
        setEmailsState(newEmails);
      }}
    />
  );
}

export default AdminContentSafetySettingsContainer;
